import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import locationImage from "../../../assets/admin/images/Google_Map.svg";
import WhCalen from "../../../assets/user/images/whcalendar.svg";
import RepeatImg from "../../../assets/user/images/Repeat.svg";
import lockedIcon from "../../../assets/user/images/lockedIcon.svg";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import { api } from "../../../utlis/provider/api.utlis";
import { decode, encode } from "base-64";
import { routes } from "../../../utlis/provider/routes.utlis";
import Loader from "../../../layouts/loader/Loader";
import ApiService from "../../../core/services/ApiService";
import { status, weekDays } from "../../../utlis/common.utlis";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "react-bootstrap";
import moment from "moment";
import toast from "react-hot-toast";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const Details = () => {
  const navigate = useNavigate();
  const localData = useLocation();
  const id = localData.state?.id;
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState();
  const [list, setList] = useState([]);
  const [coupon, setCoupon] = useState();
  const [openCouponModal, setCouponModal] = useState(false);

  const initialValuesCoupon = {
    coupon: coupon?.currentAppliedCoupon?.coupon_code ?? "",
  };

  const validationSchemaCoupon = Yup.object().shape({
    coupon: Yup.string().required("Please select a coupon"),
  });

  const getJobDetails = async (apiURL) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(apiURL);
    // console.log(response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setDetails(response.data.data);
      const responseApply = await ApiService.getAPIWithAccessToken(
        api.leadCouponApply
      );
      if (responseApply.data.status && responseApply.data.statusCode === 200) {
        setCoupon(responseApply.data.data);
      } else {
        setCoupon();
      }
    } else setDetails();
    setLoading(false);
  };

  const getCouponList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    console.log(response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setList(response.data.data.coupons);
    } else setList([]);
    setLoading(false);
  };

  const makePayment = async (id, amount) => {
    setLoading(true);
    let form = JSON.stringify({
      request_id: id,
      amount: amount,
      couponCode: coupon?.currentAppliedCoupon?.coupon_code ?? null,
    });
    const response = await ApiService.postAPIWithAccessToken(
      api.paymentUnlockRequest,
      form
    );
    if (response.data.status && response.data.statusCode === 200) {
      window.location.href = response.data.data.approvalUrl;
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const unlockJob = async (id) => {
    setLoading(true);
    let form = JSON.stringify({
      status: 1,
    });
    const response = await ApiService.putAPIWithAccessToken(
      api.providerDealStatus + `${id}`,
      form
    );
    if (response.data.status && response.data.statusCode === 200) {
      toast.success(response.data.message);
      navigate(routes.myJobs, {
        state: {
          tab: 1,
        },
      });
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const subscriptionAuth = async (api) => {
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      if (!response.data.data.accessMyJobScreen) {
        navigate(routes.subscriptionPlan);
      }
    }
  };

  const applyCoupon = async (formValue) => {
    if (formValue === "" || formValue === null || formValue === undefined) {
      toast.error("Please enter a coupon code.");
      return;
    }
    setLoading(true);
    const responseApply = await ApiService.getAPIWithAccessToken(
      api.leadCouponApply + `?couponCode=${formValue}`
    );
    if (responseApply.data.status && responseApply.data.statusCode === 200) {
      setCoupon(responseApply.data.data);
      getJobDetails(api.jobDetails + `${decode(id)}`);
      toast.success(responseApply.data.message);
      setCouponModal(false);
    } else {
      setCoupon(responseApply.data.data);
      getJobDetails(api.jobDetails + `${decode(id)}`);
      toast.error(responseApply.data.message);
    }
    setLoading(false);
  };

  const cancelCoupon = async (couponCode) => {
    setLoading(true);
    let form = JSON.stringify({
      couponCode: couponCode ?? "",
    });
    const response = await ApiService.putAPIWithAccessToken(
      api.cancelCoupon,
      form
    );
    if (response.data.status && response.data.statusCode === 200) {
      getJobDetails(api.jobDetails + `${decode(id)}`);
      toast.success(response.data.message);
      setCouponModal(false);
    } else {
      getJobDetails(api.jobDetails + `${decode(id)}`);
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    subscriptionAuth(api.subscriptionAuth);
    getJobDetails(api.jobDetails + `${decode(id)}`);
    getCouponList(api.leadCouponList + `?type=lead`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="page-header">
          <h3 className="page-title">
            <Link
              className="btn-back"
              to=""
              onClick={(e) => {
                e.preventDefault();
                navigate(-1);
              }}
            >
              <i className="mdi mdi-arrow-left-thin"></i>
            </Link>
            &nbsp;Care Job Details
          </h3>
        </div>
        <div className="Care-locked-detail" readonly>
          {!details?.makePaymentStatus ? (
            <div className="Care-locked-detail-shape">
              <div className="locked-icon">
                <img src={lockedIcon} />
              </div>
              <h3>Client Contact Information Locked</h3>
              {details?.leadUnlockedLimitExpired ? (
                <p>
                  To Unlock Contact Information Please Make Payment Of $
                  {details?.unlockRequestPrice}
                </p>
              ) : null}
            </div>
          ) : null}
          <div className="row">
            <div className="col-lg-12">
              <div className="cc-care-card">
                <div className="cc-care-card-head">
                  <div className="cc-care-id">
                    Job ID: <span>{details?.job_id ?? "NA"}</span>
                  </div>

                  <div className="cc-care-status">
                    Status:{" "}
                    <span
                      style={{ cursor: "default" }}
                      type="button"
                      className={
                        details?.request_status == "Ongoing" ||
                        details?.request_status == "Completed"
                          ? "text-success"
                          : details?.request_status == "Pending"
                          ? "text-warning"
                          : "text-danger"
                      }
                    >
                      {details?.request_status ?? "NA"}
                    </span>
                  </div>
                </div>
                <div className="care-card-body">
                  <div className="care-content">
                    <div className="title-text">
                      {details?.first_name ?? "NA"}
                    </div>
                    <div className="d-flex justify-content-between">
                      <div className="d-flex">
                        <div className="date-text">
                          <img src={WhCalen} />{" "}
                          {moment(details?.start_date).format("MM-DD-yyyy")}{" "}
                          {details?.start_time ?? "NA"}
                        </div>
                        <div className="pointtags-list mx-2">
                          <div className="tags-item1">
                            {details?.category ?? "NA"}
                          </div>
                          <div className="tags-item-sub1">
                            {details?.subcategory ?? "NA"}
                          </div>
                        </div>
                      </div>
                      <div className="tags-list float-end">
                        <div className="tags-item-sub">
                          {details?.gender == "M" ? "Male" : "Female"}
                        </div>
                        <div className="tags-item-sub mx-2">
                          Age: {details?.age ?? "NA"}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="jobs-details-point-item">
                          <h4>Email Address: </h4>
                          <p className="text-capitalize">
                            {details?.email_id ?? "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="jobs-details-point-item">
                          <h4>Fax Number: </h4>
                          <p className="text-capitalize">
                            {details?.fax != "" &&
                            details?.fax != null &&
                            details?.fax != undefined
                              ? details?.fax
                              : "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="jobs-details-point-item">
                          <h4>Phone Number: </h4>
                          <p className="text-capitalize">
                            {details?.phone ?? "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4 mt-3">
                        <div className="care-point-box">
                          <div className="care-point-icon">
                            <img src={RepeatImg} />
                          </div>
                          <div className="care-point-text">
                            <h4>Frequency: </h4>
                            <p style={{ height: "25px" }}>
                              {details?.frequency === "O"
                                ? "One Time"
                                : details?.frequency === "W"
                                ? "Repeat Weekly"
                                : "Repeat Monthly"}
                            </p>
                            <div className="care-day-list">
                              {details?.days !== null &&
                              details?.days !== "" &&
                              details?.days !== undefined
                                ? JSON.parse(details?.days).map(
                                    (element, index) => {
                                      return (
                                        <div
                                          key={index}
                                          className="tags-item-sub me-1"
                                        >
                                          {weekDays(element)}
                                        </div>
                                      );
                                    }
                                  )
                                : null}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 mt-3">
                        <div className="care-point-box">
                          <div className="care-point-text">
                            <h4>Prefered Contact: </h4>
                            <p className="text-capitalize">
                              {details?.prefer_contacted ?? "NA"}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 mt-3">
                        <div className="care-point-box">
                          <div className="care-point-text">
                            <h4>Payment Type: </h4>
                            <p className="text-capitalize">
                              {details?.payment_type ?? "NA"}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <Link
                          className="viewmorebtn mx-1"
                          to=""
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(routes.providerMessage, {
                              state: {
                                id: encode(details?.userid),
                              },
                            });
                          }}
                        >
                          <i className="fa fa-wechat"></i> Chat
                        </Link>
                      </div>
                    </div>
                    {/* <div className="tags-list">
                            <div className="tags-item-sub">
                              {details?.gender == "M" ? "Male" : "Female"}
                            </div>
                            <div className="tags-item-sub mx-2">
                              Age: {details?.age ?? "NA"}
                            </div>
                          </div>
                          <div className="date-text">
                            <img src={WhCalen} />{" "}
                            {moment(details?.start_date).format("MM-DD-yyyy")}{" "}
                            {details?.start_time ?? "NA"}
                          </div> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="jobs-details-info-card">
                <div className="jobs-details-point">
                  <div className="jobs-details-point-item">
                    <h4>Best Time To Call: </h4>
                    <p className="text-capitalize">
                      {details?.best_time_to_call ?? "NA"}
                    </p>
                  </div>
                  <div className="jobs-details-point-item">
                    <h4>Relationship: </h4>
                    <p>{details?.relationship ?? "NA"}</p>
                  </div>
                  <div className="jobsdetails-location-item">
                    <div className="jobsdetails-location-item-icon">
                      <img src={locationImage} />
                    </div>
                    <div className="jobsdetails-location-item-text">
                      <h4>Location:</h4>
                      <p>{details?.address ?? "NA"}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="jobs-details-desc-card">
                <h3>Description</h3>
                <p>{details?.description ?? "NA"}</p>
              </div>
            </div>

            {details?.providerReviewsByLoginUser != undefined &&
            details?.providerReviewsByLoginUser?.length !== 0 ? (
              <div className="col-md-12">
                <h4
                  style={{ color: "#276e91", fontWeight: "600" }}
                  className="pb-2"
                >
                  Rating & Review
                </h4>
                <div class="care-comment-list">
                  {details?.providerReviewsByLoginUser?.length !== 0
                    ? details?.providerReviewsByLoginUser?.map((ele, indx) => {
                        return (
                          <div key={indx} class="care-comment-item">
                            <div class="care-comment-profile">
                              {ele?.image !== null &&
                              ele?.image !== "" &&
                              ele?.image !== undefined ? (
                                <img src={ele?.image} alt="" />
                              ) : (
                                <img src={NoImage} alt="" />
                              )}
                            </div>
                            <div class="care-comment-content">
                              <div class="care-comment-head">
                                <div class="">
                                  <h2>{ele?.reviewGivenBy ?? "NA"}</h2>
                                  <div class="care-comment-rating">
                                    <i class="fa fa-star"></i>{" "}
                                    {ele?.rating ?? 0}
                                  </div>
                                </div>
                                <div class="care-date">
                                  <i class="fa fa-calendar"></i>{" "}
                                  {moment(ele?.created_date).format(
                                    "MM-DD-yyyy hh:mm A"
                                  )}
                                </div>
                              </div>
                              <div class="care-comment-descr">
                                {ele?.review ?? "NA"}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>
              </div>
            ) : null}
          </div>
        </div>
        {/* {details?.providers?.length !== 0
            ? details?.providers?.map((ele, indx) => {
                return (
                  <div className="col-md-12" key={indx}>
                    <div className="care-bob-user-card">
                      <div className="care-bob-user-card-box">
                        <div className="care-bob-user-card-image">
                          {ele.logo !== null &&
                          ele.logo !== "" &&
                          ele.logo !== undefined ? (
                            <img src={ele.logo} alt="" className="me-3" />
                          ) : (
                            <img
                              src={ele.profile_image}
                              alt=""
                              className="me-3"
                            />
                          )}
                        </div>
                        <div className="care-bob-user-card-content">
                          <h5 className="">{ele.fullname ?? "NA"}</h5>
                          <p className="m-0">
                            <i className="mdi mdi-checkbox-multiple-marked-circle-outline"></i>{" "}
                            {ele.provider_status} Care-Provider
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            : null} */}

        {coupon?.leadUnlockedLimitExpired == true &&
        coupon?.isCouponApplied == false &&
        list?.length !== 0 ? (
          <div className="text-center my-2">
            <span
              style={{ color: "var(--blue)", cursor: "pointer" }}
              className="text-decoration-underline"
              onClick={() => setCouponModal(true)}
            >
              Have a Coupon Code?
            </span>
          </div>
        ) : null}

        {coupon?.isCouponApplied == true ? (
          <div className="w-100">
            <div class="promo-container mx-auto">
              <div class="promo-box">
                <div class="promo-left">
                  <span class="promo-icon">✔️</span>
                  <div>
                    <p class="promo-code">
                      Coupon Code:{" "}
                      <strong>
                        {coupon?.currentAppliedCoupon?.coupon_code ?? ""}
                      </strong>
                    </p>
                  </div>
                </div>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    cancelCoupon(
                      coupon?.currentAppliedCoupon?.coupon_code ?? ""
                    );
                  }}
                  class="promo-remove"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        ) : null}

        {openCouponModal && (
          <div className="text-center w-100 d-flex justify-content-center align-items-center">
            <div className="nwi-input-wrapper">
              <input
                type="text"
                name="text"
                className="nwi-input"
                placeholder="Enter Coupon Code"
                autoComplete="off"
              />
              <button
                onClick={() => {
                  applyCoupon(document.querySelector(".nwi-input").value);
                }}
                className="nwi-Subscribe-btn"
              >
                Apply
              </button>
            </div>
            <div className="mx-2">
              <i
                onClick={() => {
                  setCouponModal(false);
                }}
                style={{ fontSize: "20px", cursor: "pointer" }}
                className="fa fa-close"
              ></i>
            </div>
          </div>
        )}

        <div className="row">
          {coupon?.leadUnlockedLimitExpired == true ? (
            <div className="col-md-12 text-center mt-2">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  makePayment(details?.id, coupon?.unLockRequestPrice ?? 0);
                }}
                className="btn btn-bl w-50"
              >
                Make Payment ${coupon?.unLockRequestPrice ?? 0}
              </button>
            </div>
          ) : (
            <div className="col-md-12 text-center mt-2">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  unlockJob(details?.id);
                }}
                className="btn btn-bl w-50"
              >
                Unlock Job
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Details;
